import { plainTextFromNoteHtml } from '../noteHtml/parseNoteHtml';

// Flattens hydrated diagram elements (the shape useElements() returns) into a
// SearchSource — the unit the matcher engine consumes. One source per diagram
// view; multi-view search will pass several sources to runSearch(). Tables
// (with their columns) and notes are emitted; areas and pen segments stay
// skipped.
export function buildSearchSource({ viewId, viewTitle = '', elements }) {
    const tables = [];
    const notes = [];

    for (const [elementId, element] of Object.entries(elements ?? {})) {
        if (!element) continue;

        if (element.type === 'note') {
            notes.push({
                viewId,
                viewTitle,
                elementId,
                text: plainTextFromNoteHtml(typeof element.text === 'string' ? element.text : ''),
                bbox: {
                    x: element.x ?? 0,
                    y: element.y ?? 0,
                    width: element.width ?? 0,
                    height: element.height ?? 0,
                },
            });
            continue;
        }

        if (element.type !== 'table') continue;

        const columnsMap = element.columns ?? {};
        const order = Array.isArray(element.columnsOrder) && element.columnsOrder.length
            ? element.columnsOrder
            : Object.keys(columnsMap);

        const columns = [];
        order.forEach((columnId, orderIndex) => {
            const column = columnsMap[columnId];
            if (!column) return;
            columns.push({
                columnId,
                columnIndex: orderIndex,
                name: typeof column.name === 'string' ? column.name : '',
                type: typeof column.type === 'string' ? column.type : '',
                flags: {
                    isPK: !!column.isPK,
                    isFK: !!column.isFK,
                    isNotNull: !!column.isNotNull,
                    isAutoIncrement: !!column.isAutoIncrement,
                    isEnum: !!column.isEnum,
                },
            });
        });

        tables.push({
            viewId,
            viewTitle,
            elementId,
            name: typeof element.name === 'string' ? element.name : '',
            bbox: {
                x: element.x ?? 0,
                y: element.y ?? 0,
                width: element.width ?? 0,
                height: element.height ?? 0,
            },
            columns,
        });
    }

    return { viewId, viewTitle, tables, notes };
}
